import PlaceModel               from '@models/map/PlaceModel';
import currentEditorStore       from '@/TokamapEditor/stores/currentEditorStore';
import { fetchEntityFromPlace } from '@/TokamapEditor/stores/EditorMercureListener';
import shapePlaceId             from '@/TokamapEditor/helpers/shapePlaceId';
import { PLACE_LABEL_SOURCE }   from '@/TokamapEditor/helpers/placeLinkedContent';
import { PLACE_IMAGE_SOURCE }   from '@/TokamapEditor/helpers/placeLinkedContent';

export default async function refreshShapesOfPlace(place: PlaceModel) {
	const editor = currentEditorStore._tokamap;

	if (!editor || !place.id) return;

	const shapes = editor.getAllShapes().filter(shape => shapePlaceId(shape) === String(place.id));

	if (!shapes.length) return;

	const entity = await fetchEntityFromPlace(place, false);
	const label = entity.entity.label || '';
	const image = entity.entity.image || '';

	editor.setShapeEntity(shapes.map(shape => shape.id), entity, { skipHistory: true, skipSave: true, skipConfirm: true });

	const textIds = shapes
		.filter(shape => shape.text?.source === PLACE_LABEL_SOURCE && shape.text.text !== label)
		.map(shape => shape.id);

	if (textIds.length) editor.setShapeText(textIds, { text: label }, { skipHistory: true });

	const imageIds = shapes
		.filter(shape => shape.image?.source === PLACE_IMAGE_SOURCE && shape.image.src !== image)
		.map(shape => shape.id);

	if (imageIds.length) await editor.setShapeImage(imageIds, { src: image }, { skipHistory: true });
}
